import { render, staticRenderFns } from "./GoogleOAuthButton.vue?vue&type=template&id=96946c88&scoped=true&"
import script from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"
export * from "./GoogleOAuthButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleOAuthButton.vue?vue&type=style&index=0&id=96946c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96946c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96946c88')) {
      api.createRecord('96946c88', component.options)
    } else {
      api.reload('96946c88', component.options)
    }
    module.hot.accept("./GoogleOAuthButton.vue?vue&type=template&id=96946c88&scoped=true&", function () {
      api.rerender('96946c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/Auth/GoogleOAuthButton.vue"
export default component.exports